export default function (value) {
  if (!value || typeof value !== 'string') {
    return '';
  }

  try {
    const isNegative = value.trim().startsWith('-');
    const cleaned = value.replace(/[^0-9:]/g, '');

    if (!cleaned) return '';

    const [h = '0', m = '0', s = '0'] = cleaned.split(':');

    const hour = Math.abs(parseInt(h, 10) || 0);
    const min = Math.min(59, Math.abs(parseInt(m, 10) || 0));
    const sec = Math.min(59, Math.abs(parseInt(s, 10) || 0));

    const pad = (n) => String(n).padStart(2, '0');
    const sign = isNegative ? '-' : '';

    return `${sign}${pad(hour)}h ${pad(min)}m ${pad(sec)}s`;
  } catch (e) {
    return '';
  }
}
